import { ButtonBox } from "../common/button/button";
import { getLabelName, getUserCurrentBranchId, getUserId } from "../../utils";
import { EinvoiceTransactionListModel } from "../../models/einvoiceTransaction/einvoiceTransactionModel";
import { useState } from "react";
import { reUploadEinvoiceTransaction } from "../../serviceBroker/envoiceTransactionServiceBroker";
import { Loading } from "../common/box/loading";
import { ErrorValidationBox } from "../common/box/errorValidationBox";
import { ValidationErrorModel } from "../../models";

export const EInvoiceTransactionReupload = ({
  data,
}: {
  data: EinvoiceTransactionListModel[];
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState<
    ValidationErrorModel[]
  >([]);
  const branchId = getUserCurrentBranchId();
  const userId = getUserId();

  const handleReupload = async () => {
    console.log(data);

    setIsLoading(true);
    try {
      if (!branchId) {
        throw new Error("branchId  is null");
      }
      const filteredData = data
        ?.filter((item) => !item.IsSuccess)
        .map((item) => ({
          TransactionId: item.TrasnactionId,
          BranchId: branchId,
          UserId: userId,
        }));
      const result = await reUploadEinvoiceTransaction(filteredData ?? []);
      if (result.Errors) {
        setValidationErrors(result.Errors);
      }
    } catch (err) {
      setValidationErrors([
        {
          MessageAr: getLabelName("error"),
          MessageEn: getLabelName("error"),
        },
      ]);
    }
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? <Loading /> : null}
      <ErrorValidationBox errors={validationErrors} />
      <ButtonBox
        iconType="receipt"
        className="btn btn-primary btn-md mb-4"
        disabled={isLoading}
        type="button"
        onClick={handleReupload}
      >
        {getLabelName("ReTry Send")}
      </ButtonBox>
    </>
  );
};
